export const ChartColors = {
  Proposed: '#008ffb',
  Approved: '#feb019',
  Completed: '#00e396',
  FinancialHold: '#F2B84D',
};
